import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Collapse, Tag } from "antd";
import { ToastContainer, toast, Bounce } from "react-toastify";
import rbacService from "../../services/rbacService";
import { PERMISSION_GROUPS, PERMISSION_MODULE_NAMES } from "../../constants/permissions";

const { Panel } = Collapse;

const RoleView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const role = location.state?.role;

  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!role) {
      navigate("/dashboard/roles");
      return;
    }

    const fetchRolePermissions = async () => {
      try {
        const data = await rbacService.getPermissionsByRole(role.id);
        setPermissions(data);
      } catch (error) {
        toast.error(
          <p dir="rtl" className="font-custom">
            خطا در بارگذاری دسترسی‌های نقش
          </p>
        );
      } finally {
        setLoading(false);
      }
    };

    fetchRolePermissions();
  }, [role, navigate]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600 font-custom">در حال بارگذاری...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen p-4">
      <div className="max-w-4xl w-full font-custom mx-auto bg-white p-6 rounded-lg shadow-md">
        <h2 className="text-xl text-center font-semibold text-gray-700 mb-4">
          مشاهده نقش
        </h2>

        <div className="space-y-4">
          <div className="flex flex-col w-full text-right">
            <label className="text-sm text-gray-600 mb-1">نام نقش:</label>
            <div className="w-full text-right p-2 border border-gray-200 rounded-md bg-gray-50">
              {role.name}
            </div>
          </div>

          <div className="flex flex-col w-full text-right">
            <label className="text-sm text-gray-600 mb-1">توضیحات:</label>
            <div className="w-full text-right p-2 border border-gray-200 rounded-md bg-gray-50">
              {role.description || "بدون توضیحات"}
            </div>
          </div>

          <div className="flex flex-col w-full text-right">
            <label className="text-sm text-gray-600 mb-2">
              دسترسی‌های تخصیص یافته:
            </label>

            {permissions.length === 0 ? (
              <div className="text-center text-gray-500 p-4">
                هیچ دسترسی‌ای تخصیص داده نشده است
              </div>
            ) : (
              <Collapse accordion>
                {Object.entries(PERMISSION_GROUPS).map(([module, modulePermissions]) => {
                  const roleModulePermissions = modulePermissions.filter((p) =>
                    permissions.includes(p.key)
                  );

                  if (roleModulePermissions.length === 0) return null;

                  return (
                    <Panel
                      header={
                        <div className="flex justify-between items-center font-custom">
                          <span>{PERMISSION_MODULE_NAMES[module]}</span>
                          <Tag color="blue">{roleModulePermissions.length}</Tag>
                        </div>
                      }
                      key={module}
                      className="font-custom"
                    >
                      <div className="space-y-2">
                        {roleModulePermissions.map((permission) => (
                          <div
                            key={permission.key}
                            className="flex items-center p-2 bg-gray-50 rounded"
                          >
                            <Tag color="green">✓</Tag>
                            <span>{permission.label}</span>
                          </div>
                        ))}
                      </div>
                    </Panel>
                  );
                })}
              </Collapse>
            )}
          </div>

          <div className="flex gap-3 justify-center mt-6">
            <button
              type="button"
              onClick={() => navigate("/dashboard/roles")}
              className="bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg text-sm px-6 py-2.5 transition-colors"
            >
              بازگشت
            </button>
          </div>
        </div>
      </div>

      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        rtl
        theme="dark"
        transition={Bounce}
      />
    </div>
  );
};

export default RoleView;
